import { loginStateExpiress, goto } from '@/common/utils';
import { acorekey, acorekeyvalue } from '@/constants';

export default {
  [acorekey]: acorekeyvalue,
  toLogin: loginStateExpiress,
  to404: function () {
    goto('/404');
  },
};
